import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

export type ShareLinkParams = {
  id: string;
  assetType: string;
};

export type ShareLinkResponse = {
  id: string;
  assetType: string;
  link: string;
};

const ShareLink = (ShareLinkParams: ShareLinkParams): Promise<ShareLinkResponse> =>
  FetchPromise.post(`${CMS_API_ROOT_URL}/share_links`, ShareLinkParams);

export const useShareLink = () => useMutation(ShareLink);
